import React from 'react';
import { useModal } from '@ui-library/modal/index';
import { SettingOutlined } from '@ant-design/icons';
import { apiAuthCaller } from '@services/apiCaller';
import useStores from '@stores/useStores';
import Button from '@ui-library/button';
import { MetaData } from '@ui-library/dynamicSelect';
import CreateResourceModalForm, { ResourcePayload } from './CreateResourceModalForm';

interface EditResourceButtonProps {
  resource: {
    id?: string;
    role: string;
  };
  sourceRole: string;
  metadata?: MetaData;
  sourceId?: string;
  onSuccess?: (resource: ResourcePayload) => void;
  disabled?: boolean;
}
const EditResourceButton = ({
  metadata,
  resource,
  sourceRole,
  sourceId,
  onSuccess,
  disabled,
}: EditResourceButtonProps) => {
  const modal = useModal();
  const { userStore } = useStores();
  const showModal = () => {
    modal.show({
      footer: null,
      content: (
        <CreateResourceModalForm
          defaultValue={resource}
          onSubmit={async (resource) => {
            if (sourceId) {
              await apiAuthCaller(userStore.token).post(
                `/cloudSources/resources/${resource.id}`,
                resource,
              );
            }
            if (onSuccess) {
              await onSuccess(resource);
            }
            modal.close();
          }}
          resources={[resource.role]}
          sourceRole={sourceRole}
          metadata={metadata!}
          onClose={() => modal.close()}
        />
      ),
    });
  };
  return (
    <>
      <SettingOutlined className="column_selection_button__cogs" onClick={() => showModal()} />
      {!disabled ? (
        <Button
          textPrimary
          className="column_selection_button__text"
          style={{ display: 'none' }}
          onClick={() => showModal()}
          name="Edit"
        />
      ) : null}
    </>
  );
};

export default EditResourceButton;
